import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"
import {Multiselect} from "multiselect-react-dropdown";
import {$POST} from "../func";
const styleselect = {
      multiselectContainer: {
            // To change css for multiselect (Width,height,etc..)
            fontSize: "14px",
            border: "1.25px solid #bababa",
            borderRadius: "4px",
      },
      searchBox: {
            // To change search box element look
            fontSize: "14px",
            minheight: "50px",
            textAlign: "right",
      },
      inputField: {
            // To change input field position or margin
            margin: "5px",
            fontSize: "14px",
      },
      chips: {
            // To change css chips(Selected options)
            //  background: '#00000000',
            border: "2px solid",
            fontSize: "14px",
      },
      optionContainer: {
            // To change css for option container
            textAlign: "right",
      },
      option: {
            // To change css for dropdown options
            fontSize: "14px",
            textAlign: "right",
      },
      groupHeading: {
            // To chanage group heading style
      },
};

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangeResponseSupervisingEngineerFloor extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  response_supervising_engineer_floor_id: "",
                  response_supervising_engineer_floor_name: "",
                  optionFloors : [],
                  selectedFloors: [],

                  orderBy: "response_supervising_engineer_floor_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  ResponseSupervisingEngineerFloor: true,
            }
      }

      handleChangeresponse_supervising_engineer_floor_name = (event) => {
            this.setState({ response_supervising_engineer_floor_name: event.target.value })
      }


      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleSelectRows = (row2) => {
            const mobiles = (row2.response_supervising_engineer_floor_numbers !== null) ? row2.response_supervising_engineer_floor_numbers.split(",") : []
            console.log("mobilesssss", mobiles)
            let t = []
            for (const mobileKey in mobiles)
                  for (const empKey in this.state.optionFloors)
                        if (Number(mobiles[mobileKey]) === this.state.optionFloors[empKey].value)
                              t.push(this.state.optionFloors[empKey])
            this.setState(
                  {
                        response_supervising_engineer_floor_id: row2.response_supervising_engineer_floor_id,
                        response_supervising_engineer_floor_name: row2.response_supervising_engineer_floor_name,
                        ResponseSupervisingEngineerFloor: false,
                        selectedFloors : t
                  },
                  () => {}
            )
      }

      ResponseSupervisingEngineerFloor = (event) => {
            this.setState({
                  response_supervising_engineer_floor_id: "",
                  response_supervising_engineer_floor_name: "",
                  ResponseSupervisingEngineerFloor: true,
                  selectedFloors : []
            })
      }

      getFloors(){
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              // var Company1 = [{ value: 0, label: "همه کارمندان " }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].floor_id,
                                          label: arr.data[k].floor_name ,
                                    })
                              }
                              self.setState(
                                  { optionFloors: Company }
                              )
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_floors")

            xhttp.open("POST", `${constants.BASE_URL}/ResponseSupervisingEngineer`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getResponseSupervisingEngineerFloor()
                                    self.getFloors()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getResponseSupervisingEngineerFloor() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_response_supervising_engineer_floor")

            xhttp.open("POST", `${constants.BASE_URL}/ResponseSupervisingEngineer`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      saveResponseSupervisingEngineerFloor = () => {
            const {  response_supervising_engineer_floor_name, selectedFloors } = this.state
            if (selectedFloors.length > 0 && response_supervising_engineer_floor_name !== "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getResponseSupervisingEngineerFloor()
                                    self.setState({ ResponseSupervisingEngineerFloor: false})
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_response_supervising_engineer_floor")
                  fd.append("response_supervising_engineer_floor_name", response_supervising_engineer_floor_name)
                  fd.append("response_supervising_engineer_floor_numbers", self.generateMobileField())

                  xhttp.open("POST", `${constants.BASE_URL}/ResponseSupervisingEngineer`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات طبقه  را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      deleteResponseSupervisingEngineerFloor = () => {
            const { response_supervising_engineer_floor_id } = this.state

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              self.ResponseSupervisingEngineerFloor()
                              self.getResponseSupervisingEngineerFloor()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_response_supervising_engineer_floor")
            fd.append("response_supervising_engineer_floor_id", response_supervising_engineer_floor_id)

            xhttp.open("POST", `${constants.BASE_URL}/ResponseSupervisingEngineer`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      changeResponseSupervisingEngineerFloor = () => {
            const { response_supervising_engineer_floor_id, response_supervising_engineer_floor_name } = this.state
            if (response_supervising_engineer_floor_id != "" && response_supervising_engineer_floor_name != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getResponseSupervisingEngineerFloor()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_response_supervising_engineer_floor")
                  fd.append("response_supervising_engineer_floor_id", response_supervising_engineer_floor_id)
                  fd.append("response_supervising_engineer_floor_name", response_supervising_engineer_floor_name)
                  xhttp.open("POST", `${constants.BASE_URL}/ResponseSupervisingEngineer`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات طبقه  را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      generateMobileField(){
            let mobiles = ""
            for (let i = 0; i<this.state.selectedFloors.length; i++)
                  if (i !== this.state.selectedFloors.length-1)
                        mobiles += this.state.selectedFloors[i].value + ","
                  else
                        mobiles += this.state.selectedFloors[i].value
            return mobiles
      }

      render() {
            const { classes } = this.props
            const {
                  agentPermision,
                  snackMode,
                  snackstr,
                  showSnack,
                  ResponseSupervisingEngineerFloor,
                  response_supervising_engineer_floor_id,
                  response_supervising_engineer_floor_name,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={12}></Grid>
                                                            
                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="نام طبقه"
                                                                        handleInputt={this.handleChangeresponse_supervising_engineer_floor_name}
                                                                        value={response_supervising_engineer_floor_name}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>

                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                            style={styleselect}
                                                                            options={this.state.optionFloors} // Options to display in the dropdown
                                                                            selectedValues={this.state.selectedFloors} // Preselected value to persist in dropdown
                                                                            onSelect={e => this.setState({selectedFloors: e})}
                                                                            onRemove={e => this.setState({selectedFloors: e})}
                                                                            // Function will trigger on remove event
                                                                            displayValue="label" // Property name to display in the dropdown options
                                                                            placeholder="طبقات "
                                                                            closeIcon="circle2"
                                                                            emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>



                                                            <Grid item xs={12}>
                                                                  <Divider />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {ResponseSupervisingEngineerFloor ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.saveResponseSupervisingEngineerFloor()
                                                                              }}
                                                                        >
                                                                              {"ثبت طبقه  جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.ResponseSupervisingEngineerFloor}
                                                                              >
                                                                                    {"طبقه  جدید"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.changeResponseSupervisingEngineerFloor()
                                                                                    }}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.deleteResponseSupervisingEngineerFloor()
                                                                                    }}
                                                                              >
                                                                                    {"حذف"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"response_supervising_engineer_floor_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={
                                                                                          orderBy === "response_supervising_engineer_floor_id"
                                                                                                ? order
                                                                                                : false
                                                                                    }
                                                                              >
                                                                                    {"آیدی طبقه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "response_supervising_engineer_floor_id"}
                                                                                          direction={
                                                                                                orderBy === "response_supervising_engineer_floor_id"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler(
                                                                                                      "response_supervising_engineer_floor_id"
                                                                                                )
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"response_supervising_engineer_floor_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"طبقه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "response_supervising_engineer_floor_name"}
                                                                                          direction={
                                                                                                orderBy === "response_supervising_engineer_floor_name"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler(
                                                                                                      "response_supervising_engineer_floor_name"
                                                                                                )
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["response_supervising_engineer_floor_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell
                                                                                                      key={"response_supervising_engineer_floor_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["response_supervising_engineer_floor_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"response_supervising_engineer_floor_name"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["response_supervising_engineer_floor_name"]}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeResponseSupervisingEngineerFloor)
